import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { rv } from "../tokens";
import { AlertCircleIcon } from "../ui/icons";

const useStyles = makeStyles((theme) => ({
  wrap: {
    maxWidth: 520,
    margin: "0 auto",
    padding: theme.spacing(6, 2),
    textAlign: "center",
  },
  ring: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    background: rv.errorBg,
    color: rv.errorFg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  title: {
    fontWeight: 700,
    fontSize: 22,
    color: rv.heading,
    margin: theme.spacing(2.5, 0, 1),
  },
  body: {
    color: rv.muted,
    fontSize: 14,
    lineHeight: 1.6,
    margin: "0 auto",
    maxWidth: 420,
  },
  primary: {
    marginTop: theme.spacing(3),
    background: rv.gold,
    color: rv.onDark,
    minHeight: 44,
    minWidth: 160,
    borderRadius: rv.radiusInput,
    boxShadow: "none",
    textTransform: "none",
    fontWeight: 700,
    "&:hover": { background: rv.goldHover },
  },
}));

interface Props {
  message: string;
  onRetry: () => void;
}

export default function ErrorState({ message, onRetry }: Props) {
  const classes = useStyles();
  return (
    <div className={classes.wrap}>
      <div className={classes.ring}>
        <AlertCircleIcon size={34} />
      </div>
      <h1 className={classes.title}>Something went wrong</h1>
      <p className={classes.body}>{message}</p>
      <Button variant="contained" className={classes.primary} onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
}
